module.exports = "/_next/static/images/avatar_Zanet-59f28b95e2d6d2a85b987c0ada9eaa42.svg";